import HTTP from '@/utils/http-common';
import { encodeOpts } from '@/utils/encode-opts';

const getOpportunities = async (params) => (await HTTP.get(`/opportunities`, {
  params: {
    limit: 100,
    orderBy: 'sortIndex',
    ascending: -1,
    ...params
  },
  paramsSerializer: encodeOpts
})).data;
const updateOpportunity = async (data) => (await HTTP.put(`/opportunities/${data._id}`, data)).data;
const createOpportunity = async (data) => (await HTTP.post(`/opportunities`, data)).data.model;
const deleteOpportunity = async (opportunity) => (await HTTP.delete(`/opportunities/${opportunity._id}`)).data;
const saveOpportunity = async (data) => !data._id ? (await createOpportunity(data)) : (await updateOpportunity(data));
const createOpportunityComment = async (opportunity, comment) => (await HTTP.post(`/opportunities/${opportunity._id}/comments`, comment)).data;

export {
  getOpportunities,
  updateOpportunity,
  createOpportunity,
  deleteOpportunity,
  saveOpportunity,
  createOpportunityComment
};
